import { cn } from '@/shared/lib/utils'
import { Modal } from 'antd'

export type UiModalSize = 'sm' | 'md' | 'lg' | 'full'

// Một nơi định nghĩa width/top theo size. Không truyền size → mặc định cũ (1024, top 120).
const SIZE_PRESET: Record<UiModalSize, { width: string; top: number }> = {
  sm: { width: 'clamp(400px, 25vw, 480px)', top: 120 },
  md: { width: 'clamp(560px, 50vw, 800px)', top: 120 },
  lg: { width: 'clamp(720px, 75vw, 1200px)', top: 120 },
  full: { width: '100vw', top: 0 },
}

// ponytail: styled(Modal) cũ không còn rule CSS nào (toàn bộ đã comment) — bọc thừa qua
// styled-components v6 dưới React 19 nghi làm gãy ref-forward mà rc-motion cần để biết đóng
// animation xong (modal bấm OK/Cancel không tắt). Dùng thẳng antd Modal, không mất style nào.
export default function UiCustomModal(props: any) {
  const { children, className, hiddenScroll, testId, size, ...rest } = props as {
    size?: UiModalSize
    [key: string]: any
  }
  const preset = size ? SIZE_PRESET[size] : undefined
  // Có size: top của size là mặc định, style tay chỉ đè key nó đặt; centered thì không gắn top
  // inline (antd tự căn giữa). Không size: giữ hành vi cũ (style tay thay hẳn, mặc định top 120).
  const style = preset
    ? rest.centered
      ? rest.style
      : { top: preset.top, ...rest.style }
    : (rest.style ?? { top: 120 })

  // testId KHÔNG có giá trị mặc định: antd giữ portal của modal đã đóng lại trong DOM, và một
  // màn có thể mount tới 4 UiCustomModal cùng lúc (xem ProductSupplyChainListContainer) — một
  // testid dùng chung sẽ khớp nhiều node và làm Playwright báo strict-mode violation.
  return (
    <Modal
      width={preset?.width ?? 1024}
      {...rest}
      style={style}
      data-testid={testId}
      className={cn(className)}
    >
      {children}
    </Modal>
  )
}
